import { PRODUCTION, DEVELOPMENT, LOCAL_COMPLIANCE_URL, COMPLIANCE_API_URL } from "./const";
import { isEmpty } from "lodash";

export function getComplianceUrl() {
  const REACT_ENV = import.meta.env.VITE_HOST_ENV;
  const COMPLIANCE_URL = !!import.meta.env.VITE_COMPLIANCE_URL && import.meta.env.VITE_COMPLIANCE_URL !== "" ? import.meta.env.VITE_COMPLIANCE_URL : LOCAL_COMPLIANCE_URL;
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return COMPLIANCE_URL;
      case PRODUCTION:
        return COMPLIANCE_URL;
      default:
        return LOCAL_COMPLIANCE_URL;
    }
  } else {
    return LOCAL_COMPLIANCE_URL;
  }
}

export const getComplianceApiUrl = (path) => {
  const COMPLIANCE_URL = !!import.meta.env.VITE_COMPLIANCE_API_URL && import.meta.env.VITE_COMPLIANCE_API_URL !== "" ? import.meta.env.VITE_COMPLIANCE_API_URL : COMPLIANCE_API_URL;
  return `${COMPLIANCE_URL}/tc/${path}`;
};
